'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import * as http from 'reporting-data/request/http';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { isSearch, translateFilters, getQuery } from '../lib/salesAnalytics/helpers';
import { DEAL_CHANGE_TYPES } from '../lib/salesAnalytics/constants';
import resolveProperties from '../lib/salesAnalytics/resolveProperties';
import generateReferences from '../lib/salesAnalytics/generateReferences';
const AGGREGATION_PROPS = ['deal_change_type', 'SUM|count', 'SUM|amount_in_home_currency'];
const SEARCH_PROPS = ['dealname', 'hs_created_in_period', 'dealstage', 'hs_deal_stage_progress', 'hs_is_closed', 'amount_in_home_currency', 'hs_amount_change_event', 'hs_amount_change_percentage', 'closedate', 'hs_close_date_progress', 'hs_manual_forecast_category', 'hs_manual_category_progress'];
const PATH_TO_PROP = {
  id: ['objectId'],
  dealname: ['properties', 'dealname', 'value'],
  dealstage: ['properties', 'dealstage', 'value'],
  amount_in_home_currency: ['properties', 'amount_in_home_currency', 'value'],
  closedate: ['properties', 'closedate', 'value'],
  hs_manual_forecast_category: ['properties', 'hs_manual_forecast_category', 'value'],
  hs_is_closed: ['properties', 'hs_is_closed', 'value']
};
const resolveAggregationData = report => http.post('/sales-reporting/deal-history/summary', {
  query: getQuery(report),
  data: {
    config: report.get('config').delete('sort')
  }
}).then(response => ({
  report,
  response
}));
const transformAggregation = ({
  report,
  response
}) => {
  const data = response.get('breakdowns').filter(breakdown => breakdown.get('count', 0) > 0).map(breakdown => breakdown.mapKeys(key => key === 'count' ? 'SUM|count' : key)).sortBy(breakdown => DEAL_CHANGE_TYPES.indexOf(breakdown.get('deal_change_type')));
  const metrics_primary = response.get('metrics_primary');
  const datasets = ImmutableMap({
    primary: Dataset({
      data
    }),
    summary: Dataset({
      data: [{
        metrics_primary
      }]
    })
  });
  return {
    report,
    response,
    datasets
  };
};
const resolveSearchData = report => http.post('/sales-reporting/deal-history/audits', {
  query: getQuery(report),
  data: {
    config: report.get('config').set('sort', List.of(ImmutableMap({
      property: 'closedate',
      order: 'DESC'
    }))),
    offset: report.getIn(['config', 'offset'])
  }
}).then(response => ({
  report,
  response
}));
const transformSearch = ({
  report,
  response
}) => {
  const data = response.get('objects').map(object => ['id', ...SEARCH_PROPS].reduce((collect, prop) => collect.set(prop, object.getIn(PATH_TO_PROP[prop] || [prop])), ImmutableMap())).map(point => point.update('closedate', Number).update('hs_amount_change_percentage', value => value / 100));
  const datasets = ImmutableMap({
    primary: Dataset({
      data,
      properties: {},
      paginationSize: response.get('total')
    }),
    summary: Dataset({
      data: [{
        metrics_primary: response.get('metrics_primary')
      }],
      properties: {
        metrics_primary: {
          type: 'number'
        }
      }
    })
  });
  return {
    report,
    datasets,
    response
  };
};
export default (report => isSearch(report) ? translateFilters(report).then(resolveSearchData).then(transformSearch).then(resolveProperties(SEARCH_PROPS)).then(generateReferences).then(({
  datasets
}) => datasets.map(dataset => ImmutableMap({
  data: dataset
}))) : translateFilters(report).then(resolveAggregationData).then(transformAggregation).then(resolveProperties(AGGREGATION_PROPS)).then(generateReferences).then(({
  datasets
}) => datasets.map(dataset => ImmutableMap({
  data: dataset
}))));